import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { PIPELINE } from "./eventosUtils";

export default function NySpeakerModal({ persons, members, onLagre, onLukk }) {
  const [form, setForm] = useState({
    personId: "", name: "", org: "", title: "", email: "", stage: "researching", ownerId: "",
  });
  const [lagrer, setLagrer] = useState(false);

  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") onLukk(); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onLukk]);

  const sett = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const gyldig = form.personId || form.name.trim();

  const lagre = async () => {
    if (!gyldig || lagrer) return;
    setLagrer(true);
    try {
      await onLagre({ ...form, personId: form.personId || null, ownerId: form.ownerId || null });
    } finally {
      setLagrer(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-[12vh] px-4" data-testid="ny-speaker-modal">
      <div className="sak-backdrop absolute inset-0 bg-black/25" onClick={onLukk} />
      <div className="sak-modal relative w-full max-w-[480px] bg-white rounded-2xl shadow-2xl border border-[#E7E4DB] p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-[15px] font-semibold">Ny speaker i pipelinen</h2>
          <button type="button" onClick={onLukk} className="text-neutral-400 hover:text-neutral-800 transition-colors">
            <X size={16} />
          </button>
        </div>

        <label className="adm-label mb-3">
          Gjenbruk eksisterende person (valgfritt)
          <select value={form.personId} onChange={(e) => sett("personId", e.target.value)} className="adm-input" data-testid="ny-speaker-person-select">
            <option value="">— Ny person —</option>
            {(persons || []).map((p) => (
              <option key={p.id} value={p.id}>{p.name}{p.org ? ` · ${p.org}` : ""}</option>
            ))}
          </select>
        </label>

        {!form.personId && (
          <div className="grid grid-cols-2 gap-3">
            <label className="adm-label col-span-2">
              Navn *
              <input value={form.name} onChange={(e) => sett("name", e.target.value)} className="adm-input" data-testid="ny-speaker-navn" />
            </label>
            <label className="adm-label">
              Organisasjon
              <input value={form.org} onChange={(e) => sett("org", e.target.value)} className="adm-input" data-testid="ny-speaker-org" />
            </label>
            <label className="adm-label">
              Rolle/tittel
              <input value={form.title} onChange={(e) => sett("title", e.target.value)} className="adm-input" />
            </label>
            <label className="adm-label col-span-2">
              E-post
              <input value={form.email} onChange={(e) => sett("email", e.target.value)} className="adm-input" />
            </label>
          </div>
        )}

        <div className="grid grid-cols-2 gap-3 mt-3">
          <label className="adm-label">
            Startstadium
            <select value={form.stage} onChange={(e) => sett("stage", e.target.value)} className="adm-input" data-testid="ny-speaker-stage">
              {PIPELINE.map((s) => (
                <option key={s.k} value={s.k}>{s.label}</option>
              ))}
            </select>
          </label>
          <label className="adm-label">
            Intern ansvarlig
            <select value={form.ownerId} onChange={(e) => sett("ownerId", e.target.value)} className="adm-input">
              <option value="">Ingen</option>
              {(members || []).map((m) => (
                <option key={m.id} value={m.id}>{m.name}</option>
              ))}
            </select>
          </label>
        </div>

        <div className="flex items-center justify-end gap-2 mt-5">
          <button type="button" onClick={onLukk} className="adm-btn-ghost">Avbryt</button>
          <button type="button" onClick={lagre} disabled={!gyldig || lagrer} className="adm-btn" data-testid="ny-speaker-lagre">
            {lagrer ? "Lagrer …" : "Legg til"}
          </button>
        </div>
      </div>
    </div>
  );
}
